import { Html5Qrcode } from 'html5-qrcode';
import onScan from 'onscan.js';
import { QrScanner } from './components/QrScanner';

class TicketValidation {
    private qrcodeScanner: Html5Qrcode;

    private container: JQuery;
    private ticketNumber: JQuery;
    private qrScanner: QrScanner;
    private scannerArea: JQuery;
    private validateNewTicketButton: JQuery | undefined;

    public init(): void {
        this.container = $(document).find('.ticket-validation');
        if (this.container.length) {
            this.ticketNumber = this.container.find('[name="ticket_number"]');
            this.ticketNumber.trigger('focus');
            this.scannerArea = this.container.find('.ticket-validation__scanner');
            this.validateNewTicketButton = this.container.find('.js-validate-new-ticket');

            if (this.scannerArea.length > 0 && this.validateNewTicketButton.length === 0) {
                this.initQrcodeScanner();
            }
        }

        onScan.attachTo(document, {
            onScan: (code: string): void => {
                switch (code.length) {
                    case 12:
                        window.location.href = window.app.ticketValidationUrl + '?ticket_number=' + code;
                        break;

                    case 11:
                        $('[name="id_code"]').val(code);
                        if ($('.ticket-office').length) {
                            $('[data-section="client"] .autocomplete').val(code).trigger('change');
                        }
                        break;
                }
            },
        });

        if (typeof this.validateNewTicketButton !== 'undefined') {
            this.validateNewTicketButton.on('click.validate-ticket', (event: JQuery.ClickEvent): void => {
                event.preventDefault();

                this.validateNewTicketButton.addClass('hidden');
                this.scannerArea.removeClass('hidden');

                this.initQrcodeScanner();
            });
        }
    }

    private initQrcodeScanner(): void {
        this.qrScanner = new QrScanner(
            this.scannerArea.attr('id'),
            this.onScanSuccess.bind(this),
            this.onScanError.bind(this)
        );
    }

    private onScanSuccess(decodedText: string): void {
        this.qrScanner.getScanner().stop();
        window.location.href = window.app.ticketValidationUrl + '?ticket_number=' + decodedText;
    }

    private onScanError(error: string): void {
        // do nothing
    }
}

const ticketValidation: TicketValidation = new TicketValidation();

export default ticketValidation;
